import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';

import * as Sentry from '@sentry/react';

import Error from './Error';

interface Props {
    children?: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = { hasError: false };

    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { error, hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.log({ error, errorInfo });
        Sentry.captureException(error, { extra: { errorInfo } });
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? <Error />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
